import { defineStore } from 'pinia'
import localforage from 'localforage'

export const useUserInfoStore = defineStore('userInfo', {
    state: () => ({
        userId: null,
        email: null,
        userName: null,
        statusMessage: null,
        showStatusMessage: false,
        showWhatIsHypospadias: false,
        lastPageURL: '/',
        userReadHipaa: false,
        carePlanCompleted: false,
        isParentAccount: false,
        ageRange:"",
        currentWyshInstance: 0,
        currentCarePlanInstance: 0,
        firstName: "",
        participantCode: "",
        hideIllustrations: false,
        token: null

    }),
    actions: {
        async saveState() {
            const plainState = JSON.parse(JSON.stringify(this.$state));
            await localforage.setItem('userInfo', plainState);
        },
        async loadState() {
            const savedState = await localforage.getItem('userInfo');
            if (savedState) {
                this.$patch(savedState);
            }
        },
        setToken(token) {
            this.token = token;
            //document.cookie = `token=${token}; Secure; HttpOnly; SameSite=Strict`;
        },
        clearToken() {
            this.token = null;
            //document.cookie = "token=; Max-Age=0; Secure; HttpOnly; SameSite=Strict";
        }
    }
});
